import { MfaMethod } from 'dashboard/models/user';
import { UserSession } from 'dashboard/models/user-session';
import Action from 'lib/interfaces/Action';

export type CurrentUserSessionActions =
  | Action<CurrentUserSessionActionType.SetUserSession, SetUserSessionPayload>
  | Action<CurrentUserSessionActionType.StartMfaMethod, StartMfaMethodPayload>
  | Action<CurrentUserSessionActionType.CancelMfa>
  | Action<CurrentUserSessionActionType.ClearSessionState>;

export enum CurrentUserSessionActionType {
  SetUserSession = 'current-user-session/SET_USER_SESSION',
  StartMfaMethod = 'current-user-session/START_MFA_METHOD',
  CancelMfa = 'current-user-session/CANCEL_MFA',
  ClearSessionState = 'current-user-session/CLEAR_SESSION_STATE',
}

interface SetUserSessionPayload {
  userSession: UserSession;
}

export function setUserSession(
  userSession: UserSession,
): Action<CurrentUserSessionActionType.SetUserSession, SetUserSessionPayload> {
  return {
    payload: {
      userSession,
    },
    type: CurrentUserSessionActionType.SetUserSession,
  };
}

interface StartMfaMethodPayload {
  method: MfaMethod;
}

export function startMfaMethod(
  method: MfaMethod,
): Action<CurrentUserSessionActionType.StartMfaMethod, StartMfaMethodPayload> {
  return {
    payload: {
      method,
    },
    type: CurrentUserSessionActionType.StartMfaMethod,
  };
}

/**
 * Aborts the current MFA method. This lets the user select a different method to try.
 */
export function cancelMfa(): Action<CurrentUserSessionActionType.CancelMfa> {
  return {
    type: CurrentUserSessionActionType.CancelMfa,
  };
}

export function clearSessionState(): Action<CurrentUserSessionActionType.ClearSessionState> {
  return {
    type: CurrentUserSessionActionType.ClearSessionState,
  };
}
